import PropTypes from 'prop-types';
import React from 'react';
import './Icon.css'
import chevronDown from './icons/chevron-down';

const ChevronDown = ({ dataId, focusable }) => (
  <div className="container-icon" data-id={dataId}>
    <svg focusable={focusable} className='icon icon-chevron-down' viewBox={chevronDown.viewBox}>
      {chevronDown.global ? (
        <g {...chevronDown.global}>
          {chevronDown.paths.map((path, i) => (
            <path {...path} key={i} />
          ))}
        </g>
      ) : (
        chevronDown.paths.map((path, i) => <path {...path} key={i} />)
      )}
    </svg>
  </div>
);

ChevronDown.defaultProps = {
  focusable: false,
  dataId: undefined
};

ChevronDown.propTypes = {
  dataId: PropTypes.string,
  focusable: PropTypes.bool
};

export default ChevronDown

